exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfooter[data-v-a1069384] {\n  color: #fff;\n  background: #111;\n  position: relative;\n  z-index: 999;\n}\n.read-more[data-v-a1069384],\n.read-more[data-v-a1069384]:hover {\n  font-size: 14px;\n  text-decoration: underline;\n}\na[data-v-a1069384]:hover {\n  text-decoration: none;\n}\niframe[data-v-a1069384] {\n  width: 100%;\n  height: 170px;\n}\np[data-v-a1069384] {\n  margin-bottom: 0.4rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1069384","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/footer.vue
// module id = 430
// module chunks = 0